import React from 'react'

interface PaginationProps {
  currentPage: number
  totalPages: number
  onPageChange: (pageNumber: number) => void
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const renderPageNumbers = () => {
    const pageNumbers: (number | string)[] = []
    const maxVisiblePages = 5

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i)
      }
    } else {
      const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2)

      if (currentPage <= halfMaxVisiblePages + 1) {
        for (let i = 1; i <= maxVisiblePages - 1; i++) {
          pageNumbers.push(i)
        }
        pageNumbers.push('...')
        pageNumbers.push(totalPages)
      } else if (currentPage >= totalPages - halfMaxVisiblePages) {
        pageNumbers.push(1)
        pageNumbers.push('...')
        for (let i = totalPages - (maxVisiblePages - 2); i <= totalPages; i++) {
          pageNumbers.push(i)
        }
      } else {
        pageNumbers.push(1)
        pageNumbers.push('...')
        for (
          let i = currentPage - halfMaxVisiblePages;
          i <= currentPage + halfMaxVisiblePages;
          i++
        ) {
          pageNumbers.push(i)
        }
        pageNumbers.push('...')
        pageNumbers.push(totalPages)
      }
    }

    return pageNumbers?.map((number, index) => {
      const isCurrentPage = typeof number === 'number' && number === currentPage
      const isEllipsis = number === '...'

      return (
        <button
          key={index}
          className={`px-4 py-2 rounded-md mx-1 focus:outline-none ${
            isCurrentPage ? 'bg-bluishGreen text-white' : 'bg-gray2 text-text1'
          }`}
          onClick={() => typeof number === 'number' && onPageChange(number)}
          disabled={isEllipsis}
        >
          {number}
        </button>
      )
    })
  }

  return (
    <div className="flex justify-center mt-4">
      <button
        className="px-4 py-2 rounded-md mx-1 focus:outline-none bg-gray2 text-text1"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        {'<'}
      </button>
      {renderPageNumbers()}
      <button
        className="px-4 py-2 rounded-md mx-1 focus:outline-none bg-gray2 text-text1"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        {'>'}
      </button>
    </div>
  )
}

export default Pagination
